// eslint-disable-next-line boundaries/element-types
import { ComponentType } from '@angular/cdk/portal';

import { DialogConfigOptions } from '@core/user-interface-legacy';

export type ImportSkillsStep = 'intro' | 'upload_file' | 'loading' | 'summary' | 'result';

export type ImportSkillsApplyResult =
  | { success: true; skillsCount: number; positionsCount: number }
  | { success: false; issues: string[] };

export interface ImportSkillsFlowData {
  id: number;
  userPrompt: string | null;
  applyResult?: ImportSkillsApplyResult;
}

export interface ImportSkillsStepDefinition {
  step: ImportSkillsStep;
  canMatch?: (data: Partial<ImportSkillsFlowData>) => boolean;
  initialData?: Partial<ImportSkillsFlowData>;
}

export interface ImportSkillsStepI {
  dialogComponent: ComponentType<any>;
  dialogConfig: DialogConfigOptions;
}

export enum GrowRole {
  CompanyManager = 'company_manager',
  CompanyHR = 'company_hr',
}

export interface SkillLevel {
  id: number;
  name: string;
  position: number;
  skillProficiencies?: SkillProficiencyRef[];
  structurePositions: StructurePosition[];
}

export interface MappingSkill {
  descriptionText: string | null;
  group: SkillGroup | null;
  name: string;
  position: number;
  proficiencies?: Proficiency[];
  skillId: number;
}

export interface SkillMapping {
  fullMappingReturned?: boolean;
  id: number;
  levels?: SkillLevel[];
  name: string;
  selectedLevelId?: number;
  skills: MappingSkill[];
  status: string;
  totalLevelsCount?: number;
  updatedAt: string;
}

export interface SkillGroup {
  id: number;
  name: string;
}

export interface Skill {
  createdAt: string;
  deprecatedEnabled?: boolean;
  descriptionText: string | null;
  filters?: string[];
  group: SkillGroup | null;
  id: number;
  name: string;
  proficiencies?: Proficiency[];
  status: string;
}

export interface SkillEntity {
  skillMappings: SkillMapping[];
  skills: Skill[];
}

export interface Proficiency {
  descriptionText: string | null;
  id: number;
  name: string;
  position: number;
}

export interface SkillProficiencyRef {
  proficiencyId: number;
  skillId: number;
}

export interface StructurePosition {
  name: string;
  positionGuid?: string;
  structurePositionId: number;
}

export interface AssignedSkill {
  skill: Skill;
  proficiency: Proficiency;
}

export interface PositionSkillEntity {
  skillMappings: SkillMapping[];
  skills: AssignedSkill[];
}
